<template>


    <div :class="styleClass">
        <a href="#" @click.prevent="click" class="item item_bottom" :data-teaser="teaser.data" :data-id="teaser.teaser_id" :data-index="teaser.index" :data-position="teaser.position"  :style="style">
            <div class="slider__content">
                <div class="slider__content_header" :style="{backgroundImage: 'url(' + teaser.path_rectangle_image + ')'}">
                    <!--<img :src="teaser.image_rectangle" v-if="!square" class="slider__content_img" >-->


                </div>
                <div class="slider__content_footer">
                    <h2 class="slider__content_title">{{teaser.title}}</h2>
                    <button @click="click" class="slider-button">{{Helper.t('subscribe')}}</button>
                    <div class="item__gradient" class="item__gradient"></div>
                </div>
            </div>
        </a>
    </div>

</template>

<script>
    // import FastAverageColor from 'fast-average-color';
    export default {
        name: "news-teaser3",

        props:{
            styleClass:String,
            teaser:Object,
            square:{
                type:Boolean,
                default:false,
            },
        },
        data(){
            return {
                gradientStyle:{},
                style:{},
                size: 50,
            }
        },
        mounted() {
            // let img = this.$refs.img;
            // img.crossorigin = '';
            // let vue = this;
            // img.addEventListener('load', function()
            // {
            //
            //
            //     let fac = new FastAverageColor();
            //     let height = this.naturalHeight;
            //
            //     let color = fac.getColor(this, {top: height - vue.size, height: vue.size});
            //
            //     var colorEnd = [].concat(color.value.slice(0, 3), 0).join(',');
            //     vue.style = {
            //         background: color.rgb,
            //         color:      color.isDark ? 'white' : 'black',
            //     };
            //
            //     vue.gradientStyle  = {background: 'linear-gradient(to bottom, ' +
            //             'rgba(' + colorEnd + ') 0%, ' + color.rgba + ' 100%)'};
            // }, false)
        },
        methods:{
            click() {
                this.Helper.adClick(this, this.teaser, true);
            }
        },
         computed: {
              crossorigin(){   
                  
               if (this.teaser.is_rtb == 0) {
                   return 'anonymous';
               } 
                
                return '';
            }
        }

    }
</script>

<style scoped>

</style>